export default "<router-outlet></router-outlet>\n\n<app-loader></app-loader>\n";